/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

export interface SystemOptions extends Record<string, any> {
    platformUrl: string;
    sentryUrl: string | null;
    appBaseUrl: string;
    gaID: string | null;
    mode: 'prod' | 'test' | 'dev';
}

interface Settings extends Record<string, SystemOptions> {
    prod: SystemOptions;
    dev: SystemOptions;
    accept: SystemOptions;
}

const defaultSettings: SystemOptions = {
    mode: 'prod',
    platformUrl: '',
    sentryUrl: null,
    appBaseUrl: '',
    gaID: null,
};

const appSettings: Settings = {
    prod: {
        ...defaultSettings,
        platformUrl: 'https://bowies.nl/bowies-core/v1/',
        gaID: 'UA-169183213-2',
    },
    accept: {
        ...defaultSettings,
        mode: 'test',
        platformUrl: 'https://bowies.nl/bowies-core-accept/v1/',
    },
    dev: {
        ...defaultSettings,
        mode: 'dev',
        platformUrl: 'http://127.0.0.1:30377/v1/',
    }
};

const mode: keyof Settings = (window.mode || 'prod') as keyof Settings;
window.settings = appSettings[mode];
window.allowCookies = true;
